import styled from 'styled-components';

export const ProductsPage = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  overflow: hidden;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom:20px;
  gap: 16px;

  @media (max-width: 1024px) {
    align-items: flex-start;
    flex-direction: column;
  }

  @media (max-width: 480px) {
    margin-bottom: 16px;

    > * {
      width: 100%;
    }
  }
`;

export const PageTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const AddProductButton = styled.button`
  background: #30D5C8;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #26a79d;
  }

  @media (max-width: 480px) {
    justify-content: center;
    width: 100%;
  }
`;
export const ProductSide = styled.div`
display: flex;
gap: 10px;
flex-wrap: wrap;

@media (max-width: 768px) {
  display: grid;
  grid-template-columns: repeat(4, minmax(72px, 1fr));
  gap: 7px;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 3px;

  > * {
    width: 100%;
    min-width: 0;
    min-height: 62px;
    padding: 7px 4px;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    font-size: 11px;
    line-height: 1.15;
    text-align: center;
    white-space: nowrap;
  }

  svg {
    flex: 0 0 auto;
    width: 19px;
    height: 19px;
  }
}
`

export const ProductsFilters = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-wrap: nowrap;
    align-items: center;
    gap: 12px;
    padding: 14px;
    margin-bottom: 20px;
    overflow-x: auto;

    > * {
      min-width: 190px;
      flex: 0 0 190px;
    }
  }
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  gap: 8px;
  flex: 1;
  max-width: 400px;

  @media (max-width: 768px) {
    max-width: 220px;
  }
`;

export const SearchInput = styled.input`
  border: none;
  background: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  color: #334155;

  &::placeholder {
    color: #94a3b8;
  }
`;

export const SearchButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #64748b;
  padding: 4px;
`;

export const CategoryFilter = styled.select`
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  min-width: 150px;
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProductCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const ProductImage = styled.div`
  height: 200px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  border-bottom: 1px solid #e2e8f0;
`;

export const ProductInfo = styled.div`
  padding: 20px;
`;

export const ProductName = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
`;

export const ProductCategory = styled.div`
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
`;

export const ProductPrice = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #26a79d;
  margin-bottom: 12px;
`;

export const ProductStock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

export const StockLabel = styled.span`
  font-size: 14px;
  color: #64748b;
`;

export const StockCount = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: #26a79d;

  &.low {
    color: #dc2626;
  }
`;

export const ProductStatus = styled.div`
  margin-bottom: 16px;
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ActiveStatusBadge = styled(StatusBadge)`
  background: #dcfce7;
  color: #166534;
`;

export const LowStockStatusBadge = styled(StatusBadge)`
  background: #fef3c7;
  color: #92400e;
`;

export const InactiveStatusBadge = styled(StatusBadge)`
  background: #fee2e2;
  color: #991b1b;
`;

export const ProductActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  font-size: 16px;
  transition: background-color 0.2s ease;

  &:hover {
    background: white;
  }

  &.edit:hover {
    background: #fef3c7;
  }

  &.delete:hover {
    background: #fee2e2;
  }

  &.view:hover {
    background: #dbeafe;
  }
`;

export const ProductsStats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: nowrap;
    gap: 12px;
    overflow-x: auto;
    padding: 2px 2px 10px;
    scroll-snap-type: x proximity;
    scrollbar-width: thin;
  }
`;

export const StatItem = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  text-align: center;

  @media (max-width: 768px) {
    min-width: 154px;
    flex: 0 0 154px;
    padding: 16px 12px;
    scroll-snap-align: start;
  }
`;

export const StatNumber = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: #30D5C8;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

export const StatLabel = styled.div`
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
`;
